enum HateLabel {
	HATEFUL = "HATEFUL",
	NOT_HATEFUL = "NOT_HATEFUL",
}

export default HateLabel;
